import { render, staticRenderFns } from "./ModalDescription.vue?vue&type=template&id=c4ebeeba&scoped=true&"
import script from "./ModalDescription.vue?vue&type=script&lang=js&"
export * from "./ModalDescription.vue?vue&type=script&lang=js&"
import style0 from "./ModalDescription.vue?vue&type=style&index=0&id=c4ebeeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ebeeba",
  null
  
)

export default component.exports